import * as React from 'react';
import { FormGroup, FormGroupFeedback, IFormGroupProps, IInputProps, Input, Intent } from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';

interface IPasswordFieldProps {
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
  inputProps?: Omit<IInputProps, 'type' | 'intent'>;
}

export default function PasswordField<T extends string>({ name, formGroupProps, inputProps }: IPasswordFieldProps) {
  const [field, meta]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasError = meta.error;
  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <Input fill={true} type="password" {...field} {...inputProps} intent={hasError ? Intent.DANGER : Intent.NONE} />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
    </FormGroup>
  );
}
